import React from "react";

const STATUS_STYLES = {
  pending_review: { label: "Pending review", className: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "Approved", className: "bg-green-50 text-green-700 border-green-200" },
  rejected: { label: "Rejected", className: "bg-red-50 text-red-700 border-red-200" },
};

const StatusBadge = ({ status }) => {
  const style = STATUS_STYLES[status] || {
    label: status || "Unknown",
    className: "bg-gray-50 text-gray-600 border-gray-200",
  };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-semibold whitespace-nowrap ${style.className}`}
    >
      {style.label}
    </span>
  );
};

export default StatusBadge;
